import Grid from '@material-ui/core/Grid'
import { navigate } from 'gatsby'
import React from 'react'
import { SecodaryBlogHeroWrapper, SecondaryHeroImageWrapper } from '../style'

//* utils
import { ASSETS } from '../../../../../constants/assets'
import { OPTIONS } from '../../../../../constants/dateOptions'
import ImgUtil from '../../../../../utils/img.utils'
import formatInlineCode from '../../../../../utils/shortTextFormatting'

//* components
import Button from '../../../../global/button'
import Typography from '../../../../global/typography'
import { generateSecondaryArticles } from './secondaryArticles'

export const generateBlogHero = (
  pageContext: any,
  primaryPost: any,
  mainBlogData: any,
  useCase: string,
  defaultLocale: string,
  isMainBlog: boolean
) => {
  const secondaryPosts = generateSecondaryArticles(pageContext, useCase, defaultLocale)
  const primaryPostData = {
    link: primaryPost.link || '/blog',
    title: primaryPost.title || 'Software robots blog post',
    subtitle: primaryPost.subtitle || '',
    image: {
      src: primaryPost.src || '',
      altText: primaryPost.altText || 'Software Robots',
    },
    date: primaryPost.date || null,
    category: primaryPost.category || '',
  }

  return isMainBlog ? (
    <Grid container spacing={2}>
      <Grid item xs={12} md={8}>
        <div
          onClick={() => navigate(primaryPostData.link)}
          title={primaryPostData.title}
          className="TopBlog__Primary">
          <div className="TopBlog__Primary-Img-Robot">
            <div className="TopBlog__Primary-Img-Container">
              {primaryPostData.image.src && (
                <img
                  className="TopBlog__Primary-Img"
                  src={ImgUtil.getResizedImageUrl(primaryPostData.image.src, '')}
                  alt={primaryPostData.image.altText}
                  width={590}
                  height={295}
                />
              )}
            </div>

            <img
              className="TopBlog__Primary-Robot-Img"
              src={ImgUtil.getResizedImageUrl(ASSETS.BLOG_ROBOT, '')}
              alt="Software Robots"
              width={178}
              height={153}
            />
          </div>

          <div className="TopBlog__Primary-Article-Txt-Container">
            {primaryPostData.date && (
              <Typography className="TopBlog__Primary-Article-Date" type="caption">
                {new Date(primaryPostData.date).toLocaleDateString(defaultLocale, OPTIONS)}
              </Typography>
            )}

            {primaryPostData.title && (
              <Typography className="TopBlog__Primary-Article-Title" type="header1">
                {formatInlineCode(primaryPostData.title)}
              </Typography>
            )}

            {primaryPostData.subtitle && (
              <Typography className="TopBlog__Primary-Article-Subtitle" type="leadXS">
                {primaryPostData.subtitle}
              </Typography>
            )}
          </div>
        </div>
      </Grid>

      <Grid item xs={12} md={4} lg={4}>
        <div className="TopBlog__Secondary">
          {generateSecondaryArticles(pageContext, useCase, defaultLocale)}
          {mainBlogData.subscribe && (
            <div
              className="TopBlog__Secondary-Article SubscribeModal__Trigger"
              title="Subscribe to the blog">
              <div className="TopBlog__Secondary-Article-Img-Container TopBlog__Secondary-Article-Img-Container--Subscribe">
                <img
                  className="TopBlog__Secondary-Img"
                  src={ImgUtil.getResizedImageUrl(ASSETS.CONTACT_EMAIL, '')}
                  alt="Envelope"
                  width={80}
                  height={80}
                />
              </div>

              <div className="TopBlog__Secondary-Article-Txt-Container">
                <div className="TopBlog__Secondary-Article-Txt-Category-Date">
                  <Typography className="TopBlog__Secondary-Article-Category" type="captionAlt">
                    {mainBlogData.subscribe.featuredCardPill}
                  </Typography>
                </div>

                <Typography className="TopBlog__Secondary-Article-Title" type="header6">
                  {formatInlineCode(mainBlogData.subscribe.featuredCardHeadline)}
                </Typography>
              </div>
            </div>
          )}
        </div>
      </Grid>
    </Grid>
  ) : (
    <SecodaryBlogHeroWrapper>
      <Grid container spacing={2}>
        <Grid item xs={12} className="Secondary__Blog__Hero-Img-Container">
          <div
            onClick={() => navigate(primaryPostData.link)}
            title={primaryPostData.title}
            className="Secondary__Blog__TopBlog__Primary">
            <div className="Secondary__Blog__TopBlog__Primary-Img-Robot">
              <SecondaryHeroImageWrapper className="TopBlog__Secondary-Img-Container">
                {primaryPostData.image.src && (
                  <img
                    className="TopBlog__Secondary-Img"
                    src={ImgUtil.getResizedImageUrl(primaryPostData.image.src, 'width=892')}
                    alt={primaryPostData.image.altText}
                    width={792}
                    height={396}
                  />
                )}
              </SecondaryHeroImageWrapper>
            </div>

            <div className="SecondaryBlog_Primary-Article-Txt-Container">
              <img
                className="TopBlog__Secodary-Robot-Img"
                src={ImgUtil.getResizedImageUrl(ASSETS.RIGHT, '')}
                alt="Software Robots"
                width={180}
                height={128}
              />

              {primaryPostData.date && (
                <Typography className="TopBlog__Primary-Article-CategoryTitle" type="captionAlt">
                  {primaryPostData.category}
                </Typography>
              )}

              {primaryPostData.title && (
                <Typography className="TopBlog__Primary-Article-Title" type="header3">
                  {primaryPostData.title}
                </Typography>
              )}

              {primaryPostData.subtitle && (
                <Typography className="TopBlog__Primary-Article-Subtitle" type="leadXS">
                  {primaryPostData.subtitle}
                </Typography>
              )}

              <Button
                href={primaryPostData.link}
                icon={true}
                text={'Read Article'}
                iconAlignment="left"
                type="text-link"
                size="small"
                theme="light"
                className="TopBlog__Primary-Article-Button"
              />
            </div>
          </div>
        </Grid>

        <Grid container spacing={2} className="Secondary__Blog__Hero-Bottom-Articles">
          {secondaryPosts?.length === 3 &&
            secondaryPosts.map((secondaryPost: any, index: number) => {
              return (
                <Grid
                  xs={12}
                  md={6}
                  lg={4}
                  key={index}
                  item
                  className="Secondary__Blog__Hero-Bottom-Posts">
                  {secondaryPost}
                </Grid>
              )
            })}
        </Grid>
      </Grid>
    </SecodaryBlogHeroWrapper>
  )
}
